import {inlineError} from '@s-ui/decorators/lib/index.js'
import {UseCase} from '@s-ui/domain'

import UserServicesFactory from '../../user/Services/factory.js'
import {HTTPTransactionRepository} from '../Repositories/HTTPTransactionRepository.js'
import {CreateTradeRequestValueObject} from '../ValueObjects/CreateTradeRequestValueObject.js'

/**
 * @implements UseCase
 */
class CreateTradeTransactionsUseCase extends UseCase {
  constructor({getCurrentUserService, httpTransactionsRepository}) {
    super()
    this._getCurrentUserService = getCurrentUserService
    this._httpTransactionsRepository = httpTransactionsRepository
  }

  static create({config}) {
    return new CreateTradeTransactionsUseCase({
      getCurrentUserService: UserServicesFactory.getCurrentUserService({config}),
      httpTransactionsRepository: HTTPTransactionRepository.create({config})
    })
  }

  @inlineError
  async execute({adId}) {
    const userEntity = await this._getCurrentUserService.execute()

    const createTradeRequest = CreateTradeRequestValueObject.create({
      adId,
      buyer: {
        userId: userEntity.getId(),
        name: userEntity.getName(),
        lastName: userEntity.getLastName(),
        email: userEntity.getEmail(),
        phone: userEntity.getPhone(),
        provinceId: userEntity.getProvinceId(),
        zipCode: userEntity.getZipCode()
      }
    })

    const [error] = await this._httpTransactionsRepository.createTrade({createTradeRequest})

    if (error) throw error
  }
}

export const factory = CreateTradeTransactionsUseCase.create
